module.exports = __webpack_public_path__ + "img/close.1fe92eb7.svg";